module.exports = __webpack_public_path__ + "img/taichung1.97fcdfd1.jpg";